import React from 'react';
import { Grid, Segment, Placeholder } from 'semantic-ui-react';

function EstablishmentLoader(props) {

    return (
        <Grid className="mt-4" columns="equal">
            <Grid.Column computer={16}>
              <Segment raised>
                <Placeholder fluid>
                  <Placeholder.Header>
                    <Placeholder.Line length="full" />
                    <Placeholder.Line />
                  </Placeholder.Header>
                </Placeholder>
              </Segment>
            </Grid.Column>
            <Grid.Column computer={16}>
              <Segment raised>
                <Placeholder fluid>
                  <Placeholder.Header image>
                    <Placeholder.Line length="short" />
                    <Placeholder.Line length="short" />
                  </Placeholder.Header>
                  <Placeholder.Paragraph>
                    <Placeholder.Line length="medium" />
                    <Placeholder.Line length="short" />
                    <Placeholder.Line length="medium" />
                  </Placeholder.Paragraph>
                  <Placeholder.Paragraph>
                    <Placeholder.Line length="short" />
                    <Placeholder.Line length="medium" />
                    <Placeholder.Line length="medium" />
                    <Placeholder.Line length="short" />
                  </Placeholder.Paragraph>
                  <Placeholder.Paragraph>
                    <Placeholder.Line length="medium" />
                    <Placeholder.Line length="short" />
                    <Placeholder.Line length="medium" />
                    <Placeholder.Line length="medium" />
                    <Placeholder.Line length="short" />
                  </Placeholder.Paragraph>
                  <Placeholder.Paragraph>
                    <Placeholder.Line length="medium" />
                    <Placeholder.Line length="short" />
                    <Placeholder.Line length="medium" />
                    <Placeholder.Line length="medium" />
                    <Placeholder.Line length="short" />
                  </Placeholder.Paragraph>
                  </Placeholder>
              </Segment>
            </Grid.Column>
          </Grid>
    )
}

export default EstablishmentLoader;